import { ChangeDetectionStrategy, Component, Input } from '@angular/core'
import { DomSanitizer, SafeHtml } from '@angular/platform-browser'

@Component({
  selector: 'flo-value-prop',
  templateUrl: './value-prop.component.html',
  styleUrls: ['./value-prop.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ValuePropComponent {
  constructor(private sanitizer: DomSanitizer) {}
  @Input()
  set proposition(value: string) {
    // this is coming from a static file in BFFx
    // src/experiences/partials/offer/offers-experience.constants.ts
    this.safeProposition = this.sanitizer.bypassSecurityTrustHtml(value)
  }
  @Input()
  label: string
  @Input()
  svgLabel = true
  @Input()
  svgWidth = '24'

  public get isSingleClickPlans(): boolean {
    return this.label === 'single-click-plans'
  }

  public get isCheckmarkPrimary(): boolean {
    return this.label === 'checkmark-primary'
  }

  public safeProposition: SafeHtml
}
